module.exports = "thead tr th {\r\n    font-size: small;\r\n    text-align:center;\r\n    font-weight:normal;\r\n}\r\n\r\ntd {\r\n    text-align:center;\r\n}"